import React from 'react';
import { AnimatedCircularProgress } from 'react-native-circular-progress';

export interface CircularProgressProps {
  percent: number;
  size: number;
  color: string;
  width?: number;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  percent,
  size,
  color,
  width = 8
}) => {
  return (
    <AnimatedCircularProgress
      size={size}
      width={width}
      fill={100}
      tintColor={color}
      backgroundColor={color}
      rotation={0}
      lineCap='square'
      arcSweepAngle={360 * (percent / 100)}
    />
  );
};

export default CircularProgress;
